module.exports = __webpack_public_path__ + "static/img/logo57.0c64a44.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo57.png
// module id = CvMD
// module chunks = 1